export function isAndroid(userAgent = navigator.userAgent): boolean {
  return /Android/i.test(userAgent);
}

export function sceneViewerIntent(modelUrl: string, name: string, pageUrl: string): string {
  const model=new URL(modelUrl);
  const page=new URL(pageUrl);
  if(model.protocol!=='https:' || model.origin!==page.origin) throw new Error('Ongeldige Android-modellink.');
  page.searchParams.delete('auto');page.searchParams.set('androidFallback','1');
  const params=new URLSearchParams({file:model.toString(),mode:'ar_preferred',title:name});
  return 'intent://arvr.google.com/scene-viewer/1.0?'+params.toString()+'#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url='+encodeURIComponent(page.toString())+';end;';
}
